import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { S } from "@/shared/constants/styles";
import { useIsMobile } from "@/shared/hooks/useMediaQuery";

export default function BudgetVsActualChart({ data }) {
  const mobile = useIsMobile();
  return (
    <div style={{ ...S.card, padding: mobile ? 16 : 22 }}>
      <div style={S.sectionTitle}>Budget vs Actual</div>
      {data.length > 0 ? (
        <ResponsiveContainer width="100%" height={mobile ? 200 : 240}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
            <XAxis dataKey="name" tick={{ fontSize: 10 }} />
            <YAxis tick={{ fontSize: 10 }} />
            <Tooltip formatter={(v) => "$" + Number(v).toFixed(2)} />
            <Legend iconSize={8} wrapperStyle={{ fontSize: 11 }} />
            <Bar dataKey="Budgeted" fill="#3B82F6" radius={[5, 5, 0, 0]} />
            <Bar dataKey="Actual" fill="#F59E0B" radius={[5, 5, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div
          style={{
            color: "#cbd5e1",
            textAlign: "center",
            padding: "60px 0",
            fontSize: 13,
          }}
        >
          Set budgets in Budget tab
        </div>
      )}
    </div>
  );
}
